import React from "react";
import { Outlet } from "react-router-dom";
import PublicHeader from "../components/marketing/PublicHeader/PublicHeader.jsx";
import TrustBanner from "../components/marketing/TrustBanner.jsx";
import Footer from "../components/marketing/Footer/Footer.jsx";

// Base marketing type is 16px (was 15px) with a 1.6 measure - marketing copy is
// read cold by people deciding whether to trust a tax product, so it gets a
// more generous setting than the dense product shell, which stays at 15px.
const MarketingLayout = () => (
  <div className="min-h-screen flex flex-col font-body text-[16px] leading-[1.6] text-[var(--ink)] bg-[var(--bg)] antialiased">
    <PublicHeader />
    <TrustBanner />
    <div className="flex-1 animate-fade">
      <Outlet />
    </div>
    <Footer />
  </div>
);

export default MarketingLayout;
